<template>
	<li
		class="menu_item__parent"
		@mouseenter="subMenuChangeDesktop"
		@mouseleave="subMenuChangeDesktop"
		:class="{
      last: last === true,
      'has-children': this.$attrs['has-children'],
      selected: this.$attrs['selected'],
			top: theme === 'top'
    }"
	>
		<div
			class="parent_container"
			:class="theme"
		>
			<a
				v-if="menu_item['url']"
				class="menu_item__parent__primary_link"
				:href="localUrlSwap(menu_item['url'])"
				:target="menu_item['target']"
				v-html="menu_item['title']"
				@mouseover="show = true"
				@mouseleave="show = false"
				:class="theme"
			></a>
			<label
				v-else
				class="menu_item__parent__primary_link"
				v-html="menu_item['title']"
			></label>

			<svg
				v-if="menu_item['target'] === '_blank'"
				class="external_link"
				xmlns="http://www.w3.org/2000/svg"
				width="15.811"
				height="15.811"
				viewBox="0 0 15.811 15.811"
			>
				<g
					id="External-Link-Icon"
					transform="translate(0.75 1.061)"
				>
					<path
						id="Path_276"
						data-name="Path 276"
						d="M16.167,14.444v4.667a1.556,1.556,0,0,1-1.556,1.556H6.056A1.556,1.556,0,0,1,4.5,19.111V10.556A1.556,1.556,0,0,1,6.056,9h4.667"
						transform="translate(-4.5 -6.667)"
						fill="none"
						stroke="#02c382"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="1.5"
					/>
					<path
						id="Path_277"
						data-name="Path 277"
						d="M22.5,4.5h4.667V9.167"
						transform="translate(-13.167 -4.5)"
						fill="none"
						stroke="#02c382"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="1.5"
					/>
					<path
						id="Path_278"
						data-name="Path 278"
						d="M15,13.056,23.556,4.5"
						transform="translate(-9.556 -4.5)"
						fill="none"
						stroke="#02c382"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="1.5"
					/>
				</g>
			</svg>

			<div
				class="has-children-indicator"
				v-if="menu_item['children'] && hasChildren && window.width > 1240"
			>
				<svg
					fill="none"
					viewBox="0 0 117 68"
				>
					<defs />
					<path
						fill="#fff"
						d="M58.5 68L0 9.70228 9.67228 0 58.5 48.6589 107.328 0 117 9.70228 58.5 68z"
					/>
				</svg>
			</div>

			<div
				class="has-children-indicator"
				v-if="menu_item['children'] && hasChildren && window.width < 1240"
				@click="subMenuChange"
			>
				<svg
					fill="none"
					viewBox="0 0 117 68"
				>
					<defs />
					<path
						fill="#fff"
						d="M58.5 68L0 9.70228 9.67228 0 58.5 48.6589 107.328 0 117 9.70228 58.5 68z"
					/>
				</svg>
			</div>

		</div>
		<transition name="slide-fade">
			<ul
				class="menu__child"
				v-if="subMenu === true && hasChildren"
			>
				<li
					v-for="(menu_child_item, index) in menu_item['children']"
					:key="index"
					:class="menu_child_item.classes"
				><a
						class="child_menu_item"
						:href="localUrlSwap(menu_child_item['url'])"
						:target="menu_child_item['target']"
						v-html="menu_child_item['title']"
					></a></li>
			</ul>
		</transition>
	</li>
</template>

<script>
import ExternalLink from '../../images/external_link.svg';

export default {
	data() {
		return {
			show: false,
			subMenu: false,
			isScrolled: false,
			externalLink: ExternalLink,
			window: {
				width: 0,
				height: 0,
			},
		};
	},

	props: {
		menu_item: {},
		selected: {},
		currentMenuItem: {
			type: Boolean,
			default: false,
		},
		menuLength: {
			default: 0,
		},
		menuNumber: {
			default: 0,
		},
		theme: {
			default: 'light',
		},
		last: {},
		hasChildren: {},
	},

	computed: {},

	watch: {
		show() {
			this.isScrolled = true;
		},
	},

	methods: {
		didScroll() {
			this.isScrolled = window.scrollY > this.topScrollThreshold;
		},

		localUrlSwap(value) {
			if (window.location.host === 'localhost:3000') {
				return value.replace('savant-energy.test', 'localhost:3000');
			} else {
				return value;
			}
		},

		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},

		subMenuChange() {
			this.subMenu = !this.subMenu;
		},

		subMenuChangeDesktop() {
			if (this.window.width > 1240) {
				this.subMenu = !this.subMenu;
			}
		},
	},
	name: 'MenuItem',
	components: {},

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('scroll', this.didScroll);
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('scroll', this.didScroll);
	},

	mounted() {
		this.handleResize();
	},

	updated() {
		this.handleResize();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.parent_container {
	position: relative;
	z-index: 200;
	display: flex;
	column-gap: 10px;
	padding: 18px 20px;
	z-index: 10;
	width: 100%;
	justify-content: space-between;
	align-items: center;

	&:hover {
		cursor: pointer;

		.has-children-indicator {
			svg {
				transition: 0.2s ease all;
				transform: rotate(180deg);

				path {
					fill: var(--gum-green);
				}
			}
		}
	}

	&.top {
		align-self: self-end;
		padding-right: 0;
		padding-left: 0;
		width: auto;

		.menu_item__parent {
			height: auto;
		}
	}

	.external_link {
		// margin-top: 2px;

		path {
			stroke: var(--gum-green);
		}
	}

	.child_indicator {
		margin-top: 6px;

		@media (min-width: $tablet) {
			path {
				fill: var(--gum-green);
			}
		}
	}
}

.menu__child {
	position: absolute;
	left: 20px;
	top: 0;
	padding: 0;
	padding-top: 56px;
	width: 270px;

	@media (max-width: $tablet) {
		margin-top: 24px;
		margin-bottom: 8px;
		position: relative;
		width: 100%;
		padding-top: 0;
		display: flex;
		flex-direction: column;
		gap: 10px;
		left: 0;
	}

	li {
		.has-children-indicator {
			width: 10px;
			height: 10px;
			display: flex;
			justify-content: center;
			align-items: center;

			// &:hover {
			// 	svg {
			// 		path {
			// 			fill: red;
			// 		}
			// 	}
			// }

			svg {
				width: 100%;
				transition: 0.2s ease all;
				transform: rotate(0deg);

				path {
					fill: var(--gum-green);
					transition: color 0.2s ease;
				}
			}
		}

		@media (max-width: $tablet) {
			background: transparent;
			border-bottom: 0 !important;
			padding: 0 !important;
		}

		&:first-of-type:not(:last-of-type) {
			padding-top: 0;

			a {
				padding: 24px 24px 12px;
			}
		}

		&:last-of-type:not(:first-of-type) {
			padding-bottom: 0;

			a {
				padding: 12px 24px 24px;
			}
		}

		&:hover {
			cursor: pointer;
		}

		a {
			color: var(--gum-green);
			transition: 0.2s ease all;
			padding: 12px 24px;
			background: var(--warm-grey);
			width: 100%;
			font: normal normal normal 15px/20px var(--primary-font-family-heading);

			@media (max-width: $tablet) {
				background: transparent;
				padding: 0;
				font: normal normal normal 15px/20px var(--primary-font-family-heading);
			}

			&:hover {
				/* background: var(--yellow); */
				cursor: pointer;
				color: var(--gum-green);
				transition: 0.2s ease all;

				@media (max-width: $tablet) {
					color: var(--gum-green);
					background: transparent;
				}
			}

			&::before {
				display: none;
			}
		}
	}
}

li {
	display: flex;

	&:hover {
		cursor: pointer;
		color: var(--gum-green);

		a,
		label {
			&::before {
				width: 100%;
				transition: 0.2s ease all;
			}
		}
	}

	a,
	label {
		color: var(--gum-green);
		display: flex;
		align-items: center;
		transition: color 0.2s ease;
		align-items: flex-start;
		text-decoration: none;
		position: relative;
		text-indent: 0;

		&:hover {
			/* color: white; */
			text-decoration: underline;
			transition: color 0.2s ease;
			cursor: pointer;
		}
	}

	.has-children-indicator {
		width: 10px;
		height: 10px;
		display: flex;
		justify-content: center;
		align-items: center;

		// &:hover {
		// 	svg {
		// 		path {
		// 			fill: red;
		// 		}
		// 	}
		// }

		svg {
			width: 100%;
			transition: 0.2s ease all;
			transform: rotate(0deg);

			path {
				fill: var(--gum-green);
				transition: color 0.2s ease;
			}
		}
	}

	&.menu_item__parent {
		color: var(--gum-green);
		display: flex;
		height: 100%;
		align-items: center;
		position: relative;

		@media (max-width: $tablet) {
			flex-direction: column;
		}

		a.menu_item__parent__primary_link {
			color: var(--gum-green);
			position: relative;
			transition: color 0.2s ease;
			font: normal normal normal 15px/20px var(--primary-font-family-heading);
			color: var(--gum-green);
			text-transform: uppercase;

			&:hover {
				/* color: white; */
				transition: color 0.2s ease;
				cursor: pointer;

				.has-children-indicator {
					svg {
						path {
							fill: var(--gum-green);
							transition: color 0.2s ease;
						}
					}
				}
			}

			&.top {
				color: var(--gum-green);
			}
		}

		label.menu_item__parent__primary_link {
			color: var(--gum-green);
			position: relative;
			transition: color 0.2s ease;

			&:hover {
				color: white;
				transition: color 0.2s ease;

				.has-children-indicator {
					svg {
						path {
							fill: var(--gum-green);
							transition: color 0.2s ease;
						}
					}
				}
			}
		}

		&.last {
			/* .parent_container {
				padding: calc(var(--spacer) * 0) 0 0 20px;
			} */

			div.inner_menu_child {
				ul.menu__child {
					display: flex;
					flex-direction: column;
					grid-column: 2 / span 1;
					left: unset;

					li {
						justify-content: flex-end;
					}
				}
			}
		}

		&.has-children {
			position: relative;
		}

		&.top {
			height: unset;

			a.menu_item__parent__primary_link {
				&::before {
					display: none;
				}
			}
		}
	}

	div.inner_menu_child {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		z-index: -10;

		.color-wrapper {
			display: flex;
			width: 100%;
			height: auto;
			padding: 104px 0 50px;
		}
	}
}

.fade-enter-active {
	animation: fade-in 0.25s;
}

.fade-leave-active {
	animation: fade-in 0.25s reverse;
}

@keyframes fade-in {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}

.slide-fade-enter-active {
	transition: all 0.25s ease;
	transition-delay: 0.25s;
}
.slide-fade-leave-active {
	transition: all 0.25s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateY(20px);
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/MenuItem.vue